// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3KFnB","productName":"Table_productName__YGy6q"};